import { useEtiquetas } from '../../hooks/useEtiquetas';
import Select from "react-select"

export const SelectEtiqueta = ({ onChange } : any) => {
    const {etiquetas} = useEtiquetas();

    const etiquetasEmBanco = etiquetas.map((etiqueta) => ({
        key: etiqueta.etiqueta,
        value: etiqueta.etiqueta,
        label: etiqueta.etiqueta,
    }));

    const etiquetaOptions = [
            ...etiquetasEmBanco,
            {
                key: '00000',
                value: '00000',
                label: 'NÃO LOCALIZADA',
            },
      ];

    const handleEtiquetaUpdate = (event: any) => {
        if(event !== null ){
            onChange(event);
        } else {
            onChange(null);
        }
    };

    return (
        <Select
        isClearable
        placeholder="Selecione uma etiqueta"
        options={etiquetaOptions}
        onChange={handleEtiquetaUpdate}
        />
    )
};
